import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { entityName, PersonOutput } from '@qtek/shared/models';

import { HttpEntityManager } from './../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class PersonService extends HttpEntityManager<
  Partial<PersonOutput>,
  PersonOutput
> {
  protected http = inject(HttpClient);

  entityName: entityName = 'Person';

  constructor() {
    super();
  }

  updatePerson(personId: string, payload: Partial<PersonOutput> = {}) {
    return this.put(payload, personId);
  }
}
